import { render, staticRenderFns } from "./CheckinTemplate.vue?vue&type=template&id=a98f2748"
import script from "./CheckinTemplate.vue?vue&type=script&lang=js"
export * from "./CheckinTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports